export default [
  {
    name: 'partners',
    path: '/partners',
    component: () => import(/* webpackChunkName: "event" */ './Index.vue'),
    meta: {
      showNavbar: true,
      title: 'Parceiros',
      icon: 'dvr',
      label: 'Parceiros',
      permission: 'partner.list'
    }
  },
  {
    name: 'partner-edit',
    path: '/partners/edit/:id',
    component: () => import(/* webpackChunkName: "event" */ './Form'),
    meta: {
      showNavbar: false,
      title: 'Parceiro - Edição',
      icon: 'dvr',
      label: 'Parceiro - Edição',
      permission: 'partner.edit'
    }
  },
  {
    name: 'partner-show',
    path: '/partners/:id/details',
    component: () => import(/* webpackChunkName: "event" */ './Show'),
    meta: {
      showNavbar: false,
      title: 'Parceiro',
      icon: 'dvr',
      label: 'Parceiro',
      permission: 'partner.list'
    },
    children: [
      { path: '/partners/:id/details/videos', component: () => import(/* webpackChunkName: "event" */ './videos/Index.vue'), name: 'partner-videos', meta: { permission: 'partner.list' } },
      { path: '/partners/:id/details/archives', component: () => import(/* webpackChunkName: "event" */ './archives/Index.vue'), name: 'partner-archives', meta: { permission: 'partner.list' } },
      { path: '/partners/:id/details/products', component: () => import(/* webpackChunkName: "event" */ './products/Index.vue'), name: 'partner-products', meta: { permission: 'partner.list' } },
      { path: '/partners/:id/details/contacts', component: () => import(/* webpackChunkName: "event" */ './contacts/Index.vue'), name: 'partner-contacts', meta: { permission: 'partner.list' } }
    ]
  },
  {
    name: 'partner-new',
    path: '/partners/novo',
    component: () => import(/* webpackChunkName: "event" */ './Form'),
    meta: {
      showNavbar: false,
      title: 'Parceiro - Adicionar',
      icon: 'dvr',
      label: 'Parceiro - Adicionar',
      permission: 'partner.add'
    }
  }
]
